/* import __COLOCATED_TEMPLATE__ from './client-section.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ContactInformationClientSection extends Component {
  @action
  setIsMinor(isMinor) {
    let clientModel = this.args.clientModel;
    if (!clientModel) return;

    clientModel.set('isMinor', isMinor);
    clientModel.emails.at(0)?.set('skipValidation', isMinor);
    this.args.onInputChange?.();
  }
}
